var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-empty-pattern */
import React, { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { GridHeaderWrapper, GridOtherContent, Wrapper } from './ReactAGGrid.Styles';
import { ActionsGenerator } from './ActionsGenerator';
import ColumnButton from '../ReactMaterialTable/ColumnButton';
import { isBaseURLAll } from '../../../api';
import _ from 'lodash';
var ReactAGGrid = function (_a) {
    var _b;
    var columns = _a.columns, rows = _a.rows, actions = _a.actions, name = _a.name, onRowClicked = _a.onRowClicked, autoResize = _a.autoResize, rowSelection = _a.rowSelection, isRowSelectable = _a.isRowSelectable, headerContent = _a.headerContent, selectAllOnIsRowSelectableChange = _a.selectAllOnIsRowSelectableChange, onSelectionChanged = _a.onSelectionChanged;
    var gridRef = useRef(null);
    var columnList = columns.map(function (col) { return ({
        label: col.headerName,
        value: col.field
    }); });
    var rowData = useState(rows)[0];
    var _c = useState(columns), columnDefs = _c[0], setColumnDefs = _c[1];
    var _items = ((_b = localStorage.getItem(name + "_table")) === null || _b === void 0 ? void 0 : _b.split(',')) || [];
    if (!_items || _items.length === 0) {
        _items = columns
            .filter(function (col) {
            return !col.hide &&
                col.field &&
                col.field !== 'actions' &&
                col.field !== 'prjacc.name';
        })
            .map(function (col) { return col.field; });
        localStorage.setItem(name + "_table", _items.toString());
    }
    var actionElement = function (actions) {
        return {
            field: 'actions',
            headerName: 'Actions',
            pinned: 'left',
            width: actions.length * 40,
            minWidth: actions.length * 40,
            sortable: false,
            resizable: false,
            filter: false,
            suppressMovable: true,
            headerClass: 'center-text-header',
            cellRenderer: function (row) { return (React.createElement(ActionsGenerator, { actions: actions, rowData: row })); }
        };
    };
    useEffect(function () {
        if (actions) {
            var tempCols = [actionElement(actions)].concat(columns);
            setColumnDefs(tempCols);
        }
    }, [columns]);
    useEffect(function () {
        if (_items)
            refactorVisibleColumns(_items, columns);
    }, []);
    var defaultColDef = useMemo(function () {
        return {
            sortable: true,
            resizable: true,
            filter: true,
            filterParams: {
                buttons: ['apply', 'clear', 'cancel', 'reset']
            },
            flex: 1,
            minWidth: 100
        };
    }, []);
    var onChangeColumnHidden = function (list) {
        var sortedList = list;
        if (_items) {
            sortedList.sort(function (a, b) { return _items.indexOf(a) - _items.indexOf(b); });
        }
        if (!_.isEqual(_items, sortedList)) {
            _items = list;
            localStorage.setItem(name + "_table", _items.toString());
            refactorVisibleColumns(list, columns);
        }
    };
    var refactorVisibleColumns = function (list, columns) {
        var columnList = columnDefs
            .map(function (column) {
            return __assign(__assign({}, column), { hide: column.field === 'actions'
                    ? false
                    : column.field === 'prjacc.name'
                        ? !isBaseURLAll()
                        : !list.find(function (lumn) { return lumn === column.field; }) });
        })
            .sort(function (a, b) {
            //Sort based on the order of the list
            return list.indexOf(a.field) - list.indexOf(b.field);
        });
        if (actions && !columnList.find(function (col) { return col.field === 'actions'; })) {
            var tempCols = [actionElement(actions)].concat(columnList);
            setColumnDefs(tempCols);
        }
        else {
            setColumnDefs(columnList);
        }
    };
    var colBtnColumns = useMemo(function () {
        return columnList.filter(function (data) { return data.value !== 'prjacc.name' && data.value !== 'actions'; });
    }, [columnList]);
    var colBtnValue = useMemo(function () {
        return _items ||
            columns
                .filter(function (col) { return !col.hide; })
                .map(function (col) { return col.field; });
    }, [_items, columns]);
    var autoSizeAll = useCallback(function (skipHeader) {
        var allColumnIds = [];
        gridRef.current.columnApi.getAllColumns().forEach(function (column) {
            allColumnIds.push(column.getId());
        });
        gridRef.current.columnApi.autoSizeColumns(allColumnIds, skipHeader);
    }, []);
    useEffect(function () {
        var _a, _b;
        if (isRowSelectable && selectAllOnIsRowSelectableChange) {
            (_b = (_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.api) === null || _b === void 0 ? void 0 : _b.selectAll();
        }
    }, [isRowSelectable, selectAllOnIsRowSelectableChange]);
    return (React.createElement(Wrapper, { className: 'ag-theme-alpine' },
        React.createElement(GridHeaderWrapper, null,
            React.createElement(GridOtherContent, null, headerContent),
            React.createElement(ColumnButton, { columns: colBtnColumns, values: colBtnValue, onVisibilityChange: function (columnList) { return onChangeColumnHidden(columnList); } })),
        React.createElement(AgGridReact, { isRowSelectable: isRowSelectable, ref: gridRef, rowData: rows, onRowClicked: function (e) {
                console.log('$$ row AG', e.data, rowData);
                if (name === 'campaignOversight')
                    onRowClicked(e, e.data);
            }, columnDefs: columnDefs, defaultColDef: defaultColDef, pagination: true, animateRows: true, onSelectionChanged: onSelectionChanged, rowSelection: rowSelection, onColumnMoved: function (props) {
                if (!props.toIndex)
                    return;
                var allColumns = props.columnApi.getAllColumns();
                var oldIdx = allColumns.findIndex(function (col) { var _a; return col.getId() === ((_a = props.column) === null || _a === void 0 ? void 0 : _a.getId()); });
                allColumns.splice(props.toIndex, 0, allColumns.splice(oldIdx, 1)[0]);
                var newColumnOrder = allColumns
                    .map(function (col) { return col.getId(); })
                    .filter(function (col) { return _items === null || _items === void 0 ? void 0 : _items.includes(col); });
                _items = newColumnOrder;
                localStorage.setItem(name + "_table", _items.toString());
            }, onVirtualColumnsChanged: function () {
                if (autoResize)
                    autoSizeAll(false);
            }, onGridColumnsChanged: function () {
                if (autoResize)
                    autoSizeAll(false);
            } })));
};
ReactAGGrid.defaultProps = {
// bla: 'test',
};
export default React.memo(ReactAGGrid, function (oldProps, newProps) {
    return JSON.stringify(oldProps.rows) === JSON.stringify(newProps.rows)
        && JSON.stringify(oldProps.columns) === JSON.stringify(newProps.columns)
        && oldProps.isRowSelectable === newProps.isRowSelectable;
});
//# sourceMappingURL=ReactAGGrid.js.map